import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { TextField } from '@material-ui/core'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import axios from 'axios'
import ReactSelect from "../../UI/ReactSelectNotClear";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import ReactSelectMulti from "../../UI/ReactMultiSelect";

const initialValues = {
  name: '',
  appointment: "",
  devicePlaceId: "",
  direction: "",
  ipAddress: "",
  modelId: "",
  typeId: ""
}

export default function Create(props) {
  const { show, onHide, onDevices, skip,
    take, filterInputs, orderBy, sortField, devicePlaceId, deviceModelId, deviceTypeId,appointmentSelect } = props
  const [isError, setIsError] = useState('')
  const [isLoading, setIsLoading] = useState(false);
  const [devicePlaceOption, setDevicePlaceOption] = React.useState(null);
  const [deviceModelOption, setDeviceModelOption] = React.useState(null);
  const [deviceTypeOption, setDeviceTypeOption] = React.useState(null);
  const [appointmentOption, setAppointmentOption] = React.useState(null);
  const [oldValue, setOldValue] = useState([]);



  const CreateSchema = Yup.object().shape({
    name: Yup.string()
    .required('Ad tələb olunur.'),
  appointment: Yup.string()
    .required('Təyinat tələb olunur.'),
  direction: Yup.string()
    .required('İstiqamət tələb olunur.'),
  ipAddress: Yup.string()
    .required('IP tələb olunur.'),
  devicePlaceId: Yup.string()
    .required('Qurğu məkanı tələb olunur.'),
  modelId: Yup.string()
    .required('Qurğu modeli tələb olunur.'),
  typeId: Yup.string()
    .required('Qurğu tipi tələb olunur.'),

  })

  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false
    }

    return false
  }

  const onPostDevice = (values, resetForm, setSubmitting) => {
    setIsLoading(true);

    const device = {
      name: values.name,
      appointment: oldValue.toString(),
      devicePlaceId: values.devicePlaceId,
      direction: values.direction,
      ipAddress: values.ipAddress,
      modelId: values.modelId,
      typeId: values.typeId
    }
    axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}device`,
      data: device,

    })
      .then((res) => {
        onDevices(orderBy, sortField, skip, take, filterInputs,)
        setSubmitting(false)
        resetForm()
        onHide(false)
        setIsLoading(false);

      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined"
            ? err.response.data.message
            : err.message;
        setIsError(message);
        setIsLoading(false);
      });
  }

  const formik = useFormik({
    initialValues,
    validationSchema: CreateSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostDevice(values, resetForm, setSubmitting)
    },
  })

  const resetForm = () => {
    onHide()
    formik.resetForm()
  }

  useEffect(() => {
    setIsError('')
  }, [show])

  function handleChangeDevicePlace(value) {
    setDevicePlaceOption(value);
    formik.setFieldValue("devicePlaceId", value.value);
  }


  function handleChangeDeviceModel(value) {
    setDeviceModelOption(value);
    formik.setFieldValue("modelId", value.value);
  }

  function handleChangeDeviceType(value) {
    setDeviceTypeOption(value);
    formik.setFieldValue("typeId", value.value);
  }

  function handleChangeAppointment(value) {
    setAppointmentOption(value);
    const mockArray=[]
    if(value){
      value.forEach(element=>{
        mockArray.push(element.value)
      })
    }
    setOldValue(mockArray);
    formik.setFieldValue("appointment", mockArray);
  }


  return (
    <Modal
      size="lg"
      aria-labelledby="create"
      centered
      className="modal pr-0"
      show={show}
      onHide={resetForm}
    >
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="create">Əlavə et</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="name"
                    name="name"
                    label="Qurğu adı "
                    placeholder="Qurğu adı "
                    className="w-100"
                    error={getInputClasses('name')}
                    {...formik.getFieldProps('name')}
                  />
                </div>
                {formik.touched.name && formik.errors.name ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.name}</div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="ipAddress"
                    name="ipAddress"
                    label="IP"
                    placeholder="IP"
                    className="w-100"
                    error={getInputClasses('ipAddress')}
                    {...formik.getFieldProps('ipAddress')}
                  />
                </div>
                {formik.touched.ipAddress && formik.errors.ipAddress ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.ipAddress}</div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <input
                    type="text"
                    name="devicePlaceId"
                    hidden
                    {...formik.getFieldProps("devicePlaceId")}
                  />

                  <ReactSelect
                    suggestions={devicePlaceId}
                    handleChangeSingle={handleChangeDevicePlace}
                    single={devicePlaceOption}
                    label="Qurğu məkanı seçin"
                    placeholder="Qurğu məkanı seçin"
                    inputId="devicePlaceId"
                  />
                </div>
                {formik.touched.devicePlaceId && formik.errors.devicePlaceId ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.devicePlaceId}</div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <input
                    type="text"
                    name="modelId"
                    hidden
                    {...formik.getFieldProps("modelId")}
                  />

                  <ReactSelect
                    suggestions={deviceModelId}
                    handleChangeSingle={handleChangeDeviceModel}
                    single={deviceModelOption}
                    label="Qurğu modeli seçin"
                    placeholder="Qurğu modeli seçin"
                    inputId="modelId"
                  />
                </div>
                {formik.touched.modelId && formik.errors.modelId ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.modelId}</div>
                  </div>
                ) : null}
              </div>

              <div className="col-12 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <input
                    type="text"
                    name="typeId"
                    hidden
                    {...formik.getFieldProps("typeId")}
                  />

                  <ReactSelect
                    suggestions={deviceTypeId}
                    handleChangeSingle={handleChangeDeviceType}
                    single={deviceTypeOption}
                    label="Qurğu tipi seçin"
                    placeholder="Qurğu tipi seçin"
                    inputId="typeId"
                  />
                </div>
                {formik.touched.typeId && formik.errors.typeId ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.typeId}</div>
                  </div>
                ) : null}


              </div>
              <div className=" col-12 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                
                  <ReactSelectMulti
                    suggestions={appointmentSelect}
                    handleChangeSingle={(value) => handleChangeAppointment(value)}
                    single={appointmentOption}
                    label="Təyinat seçin"
                    placeholder="Təyinat seçin"
                    inputId="appointment"
                    error={getInputClasses("appointment")}
                    {...formik.getFieldProps("appointment")}
                  />
                </div>
                {formik.touched.appointment && formik.errors.appointment ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.appointment}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className=" col-12 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <FormControl className="w-100">

                    <InputLabel htmlFor="direction">İstiqamət</InputLabel>
                    <Select
                      inputProps={{
                        name: "direction",
                        id: "direction",
                      }}
                      error={getInputClasses("direction")}
                      {...formik.getFieldProps("direction")}
                    >
                      <MenuItem value="ENTRANCE">Giriş</MenuItem>
                      <MenuItem value="EXIT">Çıxış</MenuItem>
                      <MenuItem value="ENTRANCE_EXIT">Giriş-Çıxış</MenuItem>

                    </Select>
                  </FormControl>
                </div>
                {formik.touched.direction && formik.errors.direction ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.direction}
                    </div>
                  </div>
                ) : null}
                
                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>
          
            </div>

          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              onHide(false)
              formik.resetForm()
            }}
          >
            Ləğv et
          </Button>
          <Button type="submit" className={isLoading ? "px-9" : ""}>
            <span>Əlavə et</span>
            {isLoading && <span className="ml-3 spinner spinner-white"></span>}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}